export default function DownloadArquivoService(dataBase64, nomeArquivo) {
  const binaryString = window.atob(dataBase64);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }

  let mime;
  const lower = nomeArquivo.toLowerCase();
  if (lower.endsWith('.pdf')) {
    mime = 'application/pdf';
  } else if (lower.endsWith('.xlsx')) {
    mime = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  } else {
    mime = 'application/octet-stream';
  }

  const blob = new Blob([bytes], { type: mime });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = nomeArquivo;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export function downloadArquivo(arquivo) {
  const bytes = new Uint8Array(atob(arquivo.arquivoBytes).split("").map(char => char.charCodeAt(0)));
  const blob = new Blob([bytes], { type: arquivo.tipo });
  const link = document.createElement("a");
  document.body.appendChild(link);
  link.href = window.URL.createObjectURL(blob);
  link.download = arquivo.nomeArquivo;
  link.click();
  document.body.removeChild(link);
}
